import { Box, Paper, Typography, CircularProgress } from "@mui/material";

export default function ParticipantStatsCard({
    totalUsers,
    filteredUsers,
    loading,
    hasData = true,
}) {
    return (
        <Paper
            elevation={2}
            sx={{
                p: 2.5,
                mb: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 3,
            }}
        >
            {loading ? (
                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        py: 1,
                    }}
                >
                    <CircularProgress size={24} />
                </Box>
            ) : !hasData ? (
                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "text.secondary",
                        fontSize: "0.9rem",
                        opacity: 0.8,
                        py: 2,
                    }}
                >
                    No assessment data available for the selected filters.
                </Box>
            ) : (
                <>
                    {/* Left: total users */}
                    <Box>
                        <Typography
                            variant="subtitle2"
                            sx={{ textTransform: "uppercase", color: "text.secondary" }}
                        >
                            Total participants
                        </Typography>
                        <Typography variant="h5" sx={{ fontWeight: 700 }}>
                            {totalUsers != null ? totalUsers : "—"}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            All users who have taken the PEARLI assessment
                        </Typography>
                    </Box>

                    {/* Right: users contributing to this view */}
                    <Box sx={{ textAlign: "right" }}>
                        <Typography
                            variant="subtitle2"
                            sx={{ textTransform: "uppercase", color: "text.secondary" }}
                        >
                            Matching current view
                        </Typography>
                        <Typography variant="h5" sx={{ fontWeight: 700 }}>
                            {filteredUsers != null ? filteredUsers : "—"}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Participants contributing to the displayed averages
                        </Typography>
                    </Box>
                </>
            )}
        </Paper>
    );
}
